import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M11.953 2a10 10 0 1 0 .094 20 10 10 0 0 0-.094-20m4.135 6.02a.65.65 0 0 1 .388.117c.08.069.13.166.142.27.014.078.03.256.017.394-.15 1.582-.802 5.418-1.133 7.189-.14.75-.416 1-.684 1.025-.58.054-1.02-.383-1.583-.752-.88-.577-1.377-.936-2.232-1.5-.987-.65-.347-1.008.215-1.591.148-.154 2.706-2.481 2.756-2.692.006-.027.012-.125-.046-.177-.059-.051-.146-.034-.208-.02q-.132.03-4.218 2.788-.599.412-1.085.4c-.356-.007-1.043-.201-1.554-.367-.626-.204-1.124-.311-1.08-.657q.033-.27.744-.553a464 464 0 0 1 5.831-2.511c2.777-1.155 3.355-1.356 3.73-1.363"
    }, null, -1)
  ]))]))
}
export default { render: render }